import React from "react";
import TableCell from "@material-ui/core/TableCell";
import * as Constants from '../../../../constants';
import theme from '../../../../assests/theme';
import { MuiTypography, MuiGrid, MuiDivider } from '../../../ui/MaterialUIComponents';

class RulesDisplay {
    constructor(cellData, bgColor) {
        this.cellData = cellData;
        this.bgColor = bgColor || this.cellData.bgColor;


    };

    get2LineMUIGrid(text1, text2) {
        return <MuiGrid item xs><MuiTypography variant="caption" align="center" >{text1}</MuiTypography>
            <MuiDivider orientation="horizontal" />
            <MuiTypography variant="caption" align="center"  >{text2}</MuiTypography>
        </MuiGrid>
    }
    get1LineMUIGrid(someText) {
        return <MuiGrid item xs><MuiTypography align="center" >{someText}</MuiTypography>
        </MuiGrid>
    }
    getCellStyle() {
        return { border: this.cellData.border };
    }
    render() {

        return <TableCell bgcolor={this.bgColor} colspan={1} data={this.cellData} align="center" style={this.getCellStyle()} >
            <MuiGrid
                container
                direction="row"
                justify="space-between"
                alignItems="flex-start">

                {this.getDisplayData()}
                {/* <MuiGrid item >
            {data.isSelected && <RulesMenuComponent
                {...this.props}
                {...this.state}
            />}
        </MuiGrid> */}
            </MuiGrid>
        </TableCell>;
    }

    /* Adding this method to get menu icon for show mode */
    renderGrid() {

        return this.getDisplayData();



    }


    getDisplayData() {
        let someText = '-';
        return this.get1LineMUIGrid(someText);
    }


}

class BlankDisplay extends RulesDisplay {
    constructor(cellData) {
        super(cellData);
    }

    getDisplayData() {
        return super.getDisplayData();
    }
}
class ElectiveSubjectRulesDisplayForTeachers extends RulesDisplay {
    //This class is to show data in the Subject cell of the elective
    constructor(cellData, electiveSubject) {
        super(cellData, Constants.CC_RULES_ELECTIVE_BG);
        this.electiveSubject = electiveSubject;
    }
    getCellStyle() {
        return { "border": this.cellData.border };
    }
    getDisplayData() {

        let fixedTeachersNTA = this.cellData.fixedTeachersAndTAsForElective;
        let numTeachersnTA = this.cellData.numberOfTeachersAndTAsForElective;
        if (fixedTeachersNTA || numTeachersnTA) {
            fixedTeachersNTA = (fixedTeachersNTA ? fixedTeachersNTA.teachersAndTAs : []) || [];
            numTeachersnTA = (numTeachersnTA ? numTeachersnTA.teachersAndTAs : []) || [];
            let fixedPreferredTeachersString = '';
            let fixedPreferredTAString = '';
            let fixedPrefer = fixedTeachersNTA.find(obj => {
                return obj.subjectCode === this.electiveSubject;
            });
            let numTs = numTeachersnTA.find(obj => {
                return obj.subjectCode === this.electiveSubject;
            });
            if (fixedPrefer) {
                fixedPreferredTeachersString = fixedPrefer.showFixedTeachersForSubjectString + ",";
                fixedPreferredTAString = fixedPrefer.showFixedTAsForSubjectString + ",";
            }
            if (numTs) {
                fixedPreferredTeachersString = fixedPreferredTeachersString + numTs.showNumberOfTeachersForSubjectString;
                fixedPreferredTAString = fixedPreferredTAString + numTs.showNumberOfTAsForSubjectString;
            }
            return this.get2LineMUIGrid(fixedPreferredTeachersString, fixedPreferredTAString);


        } else {
            return super.getDisplayData();
        }

    }
}

class ElectiveSubjectRulesDisplayForRooms extends RulesDisplay {
    //This class is to show data in the Subject cell of the elective
    constructor(cellData, electiveSubject) {
        super(cellData, Constants.CC_RULES_ELECTIVE_BG);
        this.electiveSubject = electiveSubject;
    }

    getCellStyle() {
        return { "border": this.cellData.border};
    }


    getDisplayData() {

        let prefRooms = this.cellData.sharedRoomsForElective;

        if (prefRooms && prefRooms.subjects) {
            let subjectData = prefRooms.subjects.find(obj => {
                return obj.subjectCode === this.electiveSubject;
            });
            return this.get1LineMUIGrid(subjectData.showSharedRoomsForSubjectString);
        } else {
            return super.getDisplayData();
        }

    }
}

class ElectiveAssignedDisplayForTeachers extends RulesDisplay {
    //This class is to show data in the Subject cell of the elective
    constructor(cellData, electiveSubject) {
        super(cellData, Constants.CC_RULES_ELECTIVE_BG);
        this.electiveSubject = electiveSubject;
    }
    getCellStyle() {
        return { "border": this.cellData.border };
    }
    getDisplayData() {

        if (this.cellData.assignedData && this.cellData.assignedData.subjects && this.cellData.assignedData.subjects.length > 0) {
            let assignedDataSubs = this.cellData.assignedData.subjects;
            let assignedTeachersText = "";
            let assignedTAsText = "";

            let thisSubject = assignedDataSubs.find(obj => {
                return obj.code === this.electiveSubject.toLowerCase();
            });

            if (thisSubject) {
                let tas = thisSubject.tas || [];
                let teachers = thisSubject.teachers || [];

                assignedTeachersText = assignedTeachersText + teachers.toString();
                assignedTAsText = assignedTAsText + tas.toString();
            }


            return this.get2LineMUIGrid(assignedTeachersText.toUpperCase(), assignedTAsText.toUpperCase());
        } else {
            return super.getDisplayData();
        }


    }
}

class ElectiveAssignedDisplayForRooms extends RulesDisplay {
    //This class is to show data in the Subject cell of the elective
    constructor(cellData, electiveSubject) {
        super(cellData, Constants.CC_RULES_ELECTIVE_BG);
        this.electiveSubject = electiveSubject;
    }

    getCellStyle() {
        return { "border": this.cellData.border};
    }

    getDisplayData() {
        if (this.cellData.assignedData && this.cellData.assignedData.subjects && this.cellData.assignedData.subjects.length > 0) {
            let assignedDataSubs = this.cellData.assignedData.subjects;
            let assignedRoomsText = "";


            let thisSubject = assignedDataSubs.find(obj => {
                return obj.code.toLowerCase() === this.electiveSubject.toLowerCase();
            });

            if (thisSubject) {

                let rooms = thisSubject.rooms || [];

                assignedRoomsText = assignedRoomsText + rooms.toString();

            }


            return this.get1LineMUIGrid(assignedRoomsText.toUpperCase());
        } else {
            return super.getDisplayData();
        }

    }
}

class SubjectsAssignedDisplayRooms extends RulesDisplay {
    constructor(cellData) {
        super(cellData);
    }

    getDisplayData() {
        if (this.cellData.assignedData && this.cellData.assignedData && this.cellData.assignedData.rooms) {

            let assignedRoomsText = "";
            let rooms = this.cellData.assignedData.rooms || [];
            assignedRoomsText = assignedRoomsText + rooms.toString();

            return this.get1LineMUIGrid(assignedRoomsText.toUpperCase());
        } else {
            return super.getDisplayData();
        }
    }
}

class SubjectsAssignedDisplayTeachers extends RulesDisplay {
    constructor(cellData) {
        super(cellData);
    }

    getDisplayData() {
        if (this.cellData.assignedData && this.cellData.assignedData) {

            let assignedTeachersText = "";
            let assignedTAsText = "";

            let tas = this.cellData.assignedData.tas || [];
            let teachers = this.cellData.assignedData.teachers || [];

            assignedTeachersText = assignedTeachersText + teachers.toString();
            assignedTAsText = assignedTAsText + tas.toString();

            return this.get2LineMUIGrid(assignedTeachersText.toUpperCase(), assignedTAsText.toUpperCase());
        } else {
            return super.getDisplayData();
        }
    }
}

class SubjectsRulesDisplay extends RulesDisplay {
    constructor(cellData) {
        super(cellData);
    }

    getDisplayData() {
        return super.getDisplayData();
    }
}

class SubjectsRulesDisplayPeriod extends SubjectsRulesDisplay {
    constructor(cellData) {
        super(cellData);
    }

    getDisplayData() {

        let totalPeriodStr = this.cellData.totalPeriod != undefined ? this.cellData.totalPeriod.count + '' : this.cellData[Constants.RULES_TOTAL_PERIOD_DATATABLE_SHOW_KEY] || '';
        let multiPeriodStr = '';
        /* if (this.cellData.totalPeriod) {
            totalPeriodStr = this.cellData.totalPeriod.count + '';
        } */
        if (this.cellData.multiPeriod) {
            multiPeriodStr = this.cellData.multiPeriod.showMultiPeriodString;
        }
        return this.get2LineMUIGrid(totalPeriodStr, multiPeriodStr);

    }
}

class SubjectsRulesDisplayPeriodPref extends SubjectsRulesDisplay {
    constructor(cellData) {
        super(cellData);
    }

    getDisplayData() {
        let preferedPeriod = '-';
        if (this.cellData
            && this.cellData.preferredPeriod !== undefined
            && this.cellData.preferredPeriod.showPreferredPeriodString !== "") {
            //This is for subjects
            preferedPeriod = this.cellData.preferredPeriod.showPreferredPeriodString;
        }
        return this.get1LineMUIGrid(preferedPeriod.replace(/Period/g, 'P'));
    }
}

class SubjectsRulesDisplayRooms extends SubjectsRulesDisplay {
    constructor(cellData) {
        super(cellData);
    }

    getDisplayData() {
        let roomText = '-';
        if (this.cellData) {
            //This is for subjects
            if (this.cellData.sharedRoomsForSubject !== undefined
                && this.cellData.sharedRoomsForSubject.showSharedRoomsForSubjectString != "") {
                roomText = this.cellData.sharedRoomsForSubject.showSharedRoomsForSubjectString;
            }
        }
        return this.get1LineMUIGrid(roomText);
    }
}



class SubjectsRulesDisplayTeachers extends SubjectsRulesDisplay {
    constructor(cellData) {
        super(cellData);
    }

    getDisplayData() {
        let fixedPreferredTeachersString = '-';
        let fixedPreferredTAString = '-';
        if (this.cellData) {
            //This is for subjects
            let fixedTeachers = this.cellData.fixedTeachersAndTAsForSubject;
            let numTeachers = this.cellData.numberOfTeachersAndTAsForSubject;
            if (fixedTeachers) {
                fixedPreferredTeachersString = fixedTeachers.showFixedTeachersForSubjectString;
                fixedPreferredTAString = fixedTeachers.showFixedTAsForSubjectString;
            }
            if (numTeachers) {
                fixedPreferredTeachersString = fixedPreferredTeachersString + ' , ' + numTeachers.showNumberOfTeachersForSubjectString;
                fixedPreferredTAString = fixedPreferredTAString + ' , ' + numTeachers.showNumberOfTAsForSubjectString;
            }

            return this.get2LineMUIGrid(fixedPreferredTeachersString, fixedPreferredTAString);
        }
    }
}

export {
    SubjectsRulesDisplayPeriod, SubjectsRulesDisplayTeachers, SubjectsRulesDisplayRooms, SubjectsRulesDisplayPeriodPref,
    ElectiveSubjectRulesDisplayForTeachers, ElectiveSubjectRulesDisplayForRooms,
    SubjectsAssignedDisplayRooms, SubjectsAssignedDisplayTeachers,
    ElectiveAssignedDisplayForTeachers, ElectiveAssignedDisplayForRooms,
    BlankDisplay
}
